import * as React from 'react'

import './UserMenu.css'

import Avatar from '../Elements/Avatar'

import onClickOutside from 'react-onclickoutside';

interface IUserMenuProps {
    onSignOutRequested: () => void
    onClickOutside: () => void
}

interface IUserMenuState {
    name: string,
    imageUrl: string
}

class UserMenu extends React.Component<IUserMenuProps, IUserMenuState> {
    public constructor(props: any) {
        super(props);
        this.state = {
            name: "",
            imageUrl: ""
        };
    }
    public componentWillMount() {
        this.setState({
            name: window.localStorage.getItem('name') as string,
            imageUrl: window.localStorage.getItem('imageUrl') as string
        });
    }

    public handleClickOutside(event: any) {
        this.props.onClickOutside();
    }

    public render() {
        return (
            <div className="UserMenu">
                <div className="UserMenu__top-bar">
                    <Avatar size="small" imageUrl={this.state.imageUrl} />
                    <span className="UserMenu__user-name">{this.state.name}<span /></span>
                </div>

                <div className="UserMenu__text">Closed Beta<div /></div>
                {/*
                <div className="UserMenu__button">Account <div /></div>
                <div className="UserMenu__button">Support <div /></div>
                <div className="UserMenu__button UserMenu__invite-button">
                    <i className="material-icons">group-add</i>
                    <span>Invite Friends<span /></span>
                </div>
                  */}
                <div className="UserMenu__bottom-bar">
                    <div className="UserMenu__bottom-bar__button" onClick={this.props.onSignOutRequested}>
                        Sign Out <div />
                    </div>
                </div>
            </div>
        );
    }
}

export default onClickOutside(UserMenu);



// WEBPACK FOOTER //
// ./src/App/Blocks/UserMenu.tsx